module.exports = __webpack_public_path__ + "static/media/comment2_2.20018d06.png";